export type Difficulty = 'easy' | 'medium' | 'hard' | 'very_hard' | 'custom'

export interface Exam {
  id: string
  name: string
  examDate: Date
  totalPages: number
  difficulty: Difficulty
  customMinutesPerPage?: number
  revisionDays: number
  color: string
}

export interface DayPlan {
  date: Date
  isRestDay: boolean
  isExamDay: boolean
  examName?: string
  examColor?: string
  subjects: SubjectPlan[]
}

export interface SubjectPlan {
  examId: string
  examName: string
  color: string
  startPage: number
  endPage: number
  pages: number
  minutes: number
  isRevision: boolean
  progressPercent: number
}

export interface StudyPlan {
  days: DayPlan[]
  totalDays: number
  avgHoursPerDay: number
  stressLevel: 'verylow' | 'low' | 'medium' | 'high' | 'veryhigh'
}

export interface WizardState {
  step: number
  examCount: number
  restDays: {
    enabled: boolean
    weekDays: number[]
    specificDates: Date[]
  }
  studyMode: 'mixed' | 'separate'
  exams: Exam[]
}

export const EXAM_COLORS = [
  '#1c3fff',
  '#ff4d1c',
  '#00b86b',
  '#ffb800',
  '#9b59b6',
  '#00bcd4',
]

export const DIFFICULTY_MINUTES: Record<Difficulty, number> = {
  easy: 3,
  medium: 5,
  hard: 8,
  very_hard: 12,
  custom: 0,
}
